__turbopack_context__.v({
  "card": "GetStarted-module__v_jTyG__card",
  "cardContent": "GetStarted-module__v_jTyG__cardContent",
  "cardSubtitle": "GetStarted-module__v_jTyG__cardSubtitle",
  "cardTitle": "GetStarted-module__v_jTyG__cardTitle",
  "ctaRow": "GetStarted-module__v_jTyG__ctaRow",
  "grid": "GetStarted-module__v_jTyG__grid",
  "image": "GetStarted-module__v_jTyG__image",
  "imageWrap": "GetStarted-module__v_jTyG__imageWrap",
  "insetBorder": "GetStarted-module__v_jTyG__insetBorder",
  "primaryCta": "GetStarted-module__v_jTyG__primaryCta",
  "section": "GetStarted-module__v_jTyG__section",
  "stepBadge": "GetStarted-module__v_jTyG__stepBadge",
  "title": "GetStarted-module__v_jTyG__title",
});
